import {
  hasLeadPrefill,
  isLeadPrefillKey,
  parseLeadPrefill,
  type LeadPrefill,
} from '@doorly/shared';

/**
 * Lien de pré-remplissage (`/leads/new#nom=…&prenom=…`, cf. `lead-prefill.ts`
 * dans shared). Capté AU DÉMARRAGE, avant la connexion : le vendeur peut
 * arriver déconnecté, et l'écran de connexion ne conserve pas l'URL. Les
 * données sont mises de côté dans l'onglet (30 min) et RETIRÉES de la barre
 * d'adresse — elles ne restent ni dans l'historique ni dans un favori.
 */
const KEY = 'doorly:lead-prefill';
const TTL_MS = 30 * 60 * 1000;

export function capturePrefillFromUrl(): void {
  try {
    const url = new URL(window.location.href);
    const fromHash = parseLeadPrefill(url.hash);
    const fromQuery = parseLeadPrefill(url.search);
    const prefill: LeadPrefill = { ...fromQuery, ...fromHash };
    if (!hasLeadPrefill(prefill)) return;
    sessionStorage.setItem(KEY, JSON.stringify({ at: Date.now(), prefill }));
    // Nettoie la barre d'adresse : fragment entier s'il portait les données,
    // et seulement les clés connues de la query (les autres paramètres restent).
    if (hasLeadPrefill(fromHash)) url.hash = '';
    for (const k of [...url.searchParams.keys()]) {
      if (isLeadPrefillKey(k)) url.searchParams.delete(k);
    }
    window.history.replaceState(window.history.state, '', url.toString());
  } catch {
    // Stockage indisponible (navigation privée stricte) : pas de
    // pré-remplissage, la création de fiche reste utilisable.
  }
}

function read(): LeadPrefill | null {
  try {
    const raw = sessionStorage.getItem(KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as { at?: number; prefill?: LeadPrefill };
    if (!parsed.prefill || !parsed.at || Date.now() - parsed.at > TTL_MS) {
      sessionStorage.removeItem(KEY);
      return null;
    }
    return parsed.prefill;
  } catch {
    return null;
  }
}

/** Un pré-remplissage attend d'être utilisé (redirection après connexion). */
export function hasPendingPrefill(): boolean {
  return read() !== null;
}

/** Lit ET efface le pré-remplissage (une seule fiche par lien). */
export function consumePrefill(): LeadPrefill | null {
  const prefill = read();
  try {
    sessionStorage.removeItem(KEY);
  } catch {
    /* rien */
  }
  return prefill;
}
